import { doc, onSnapshot, serverTimestamp, setDoc, type Unsubscribe } from 'firebase/firestore';
import { db } from './firebase';
import type { PurchasingPolicy } from '../types/purchasing';
import { PURCHASING_POLICY_DOC_ID, parsePurchasingPolicy } from './purchasingPolicy';

const SETTINGS_COLLECTION = 'financeSettings';

export function subscribePurchasingPolicy(
  onSettings: (policy: PurchasingPolicy) => void,
  onError?: (err: unknown) => void,
): Unsubscribe {
  return onSnapshot(
    doc(db, SETTINGS_COLLECTION, PURCHASING_POLICY_DOC_ID),
    snap => onSettings(parsePurchasingPolicy(snap.data())),
    err => {
      console.warn('[purchasingPolicy] listen failed — using defaults', err);
      onSettings(parsePurchasingPolicy(undefined));
      onError?.(err);
    },
  );
}

export async function savePurchasingPolicy(
  policy: PurchasingPolicy,
  by: { userId: string; userName?: string },
): Promise<void> {
  const parsed = parsePurchasingPolicy(policy as unknown as Record<string, unknown>);
  await setDoc(
    doc(db, SETTINGS_COLLECTION, PURCHASING_POLICY_DOC_ID),
    {
      bands: parsed.bands,
      paymentMethods: parsed.paymentMethods,
      fallbackApproverUserId: parsed.fallbackApproverUserId || null,
      salesTaxPct: parsed.salesTaxPct,
      holdReasons: parsed.holdReasons,
      updatedAt: serverTimestamp(),
      updatedBy: by.userId,
      ...(by.userName ? { updatedByName: by.userName } : {}),
    },
    { merge: true },
  );
}
